<template>

      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Izdelava obrazca</h1>
        
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
        <h2>Obrazec <input type="text" v-model="certifikat.naziv"/>,št.:<input type="text" v-model="certifikat.stevilkaobrazca"/>, revizija: <input type="text" v-model="certifikat.revizija"/>
        </h2>
        <h3>Datum izdelave: <input type="date" v-model="certifikat.datumizdaje"/> - Datum veljavnosti:<input type="date" v-model="certifikat.datumveljavnosti"/></h3>
        

                           
   <!-- <FormBuilder v-model="configuration"></FormBuilder> -->
   <!--<FormBuilder v-bind:form="{display: 'form'}" v-bind:options="{}" v-on:change="(schema) => console.log(schema)"></FormBuilder>-->
      <div id="formio"></div>
        <button
                             
                                title="Shrani"
                                class="k-button k-primary"
                                @click="shraniCertifikat"
                            >
                                Shrani
                            </button>
    </div>
</div> 

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex';
//import {FormBuilder} from 'v-form-builder';
//import { FormBuilder } from 'vue-formio';
import Vue from 'vue';
export default {
    name: "MyAdminProMaxComponent",
  props:['obrazecid'],
  // components:{FormBuilder},
    data () {
        return {
             builder: {}
        }
    },
    created () {
          
    //Formio.builder(document.getElementById('formio')); 
    this.vrnipoobrazecid
    },
    mounted(){

    let fa = document.createElement('link');
    fa.setAttribute('href', 'https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');
    fa.setAttribute('rel', 'stylesheet');
    document.head.appendChild(fa);
    let bs = document.createElement('link');
    bs.setAttribute('href', 'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css');
    bs.setAttribute('rel', 'stylesheet');
    document.head.appendChild(bs);
    let cs = document.createElement('link');
    cs.setAttribute('href', 'https://cdn.form.io/formiojs/formio.full.min.css');
    cs.setAttribute('rel', 'stylesheet');
    document.head.appendChild(cs);

    
    /*let formio = document.createElement('script');
    formio.setAttribute('src', 'https://cdn.form.io/formiojs/formio.full.min.js');
    document.head.appendChild(formio);*/

    //this.vrniPoId({id:this.obrazecid}).then(
          //  ()=>{this.configuration=JSON.parse(this.certifikat.obrazecJson)});
        if(this.obrazecid)
            this.vrniPoId({id:this.obrazecid}).then(()=>{
                    console.log("anložil sem podatke");
                    Formio.builder(document.getElementById('formio'),JSON.parse(this.certifikat.obrazecJson)).then(b=>{
                        console.log("shranim si builder ref");
                        this.builder=b;
                    });
    }
    )
    else{
        
        Vue.set(this.certifikat, 'datumizdaje',new Date().toISOString().substr(0, 10));
        Vue.set(this.certifikat, 'datumveljavnosti',new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().substr(0, 10));
        Formio.builder(document.getElementById('formio')).then(b=>{
                        console.log("shranim si builder ref");
                        this.builder=b;    
    })
            }

    },


    computed: {
         ...mapState('obrazec', ['certifikat']),
         
           },
    methods: {

        ...mapActions('obrazec', ['vrniPoId','saveOne']),
        shraniCertifikat: function(e,d){
             Vue.delete(this.certifikat, 'datumveljavnosti');
             Vue.delete(this.certifikat, 'datumizdaje');
             Vue.set(this.certifikat,'obrazecJson',JSON.stringify(this.builder.form));
             console.log(JSON.stringify(this.builder.form));
             this.saveOne();
    },
        
    }
};
</script>

